import axios from "axios";

import {
  DEVICE_CODE,
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  EXPIRATION_DATE
} from "config";

axios.interceptors.response.use(
  (resp) => resp,
  (error: any) => {
    const config = error?.config ?? {};
    const status = error?.response?.status;

    // Reconstruct full URL from baseURL + url
    const fullUrl = config.baseURL
      ? new URL(config.url ?? "", config.baseURL).href
      : (config.url ?? "");

    // Match /livly/view/<deviceCode>/token with optional trailing slash, ignoring query string
    const isTokenPolling = (() => {
      try {
        const { pathname } = new URL(fullUrl);
        return /\/livly\/view\/[^/]+\/token\/?$/.test(pathname);
      } catch {
        return false;
      }
    })();

    // Silently ignore 403 for token polling endpoint (expected during device setup)
    if (status === 403 && isTokenPolling) {
      return Promise.resolve({
        ...error.response,
        data: null
      });
    }

    // Device code revoked — clear auth and force re-activation
    const message = error?.response?.data?.Message ?? "";
    if (
      status === 400 &&
      typeof message === "string" &&
      message.toLowerCase().includes("revoked")
    ) {
      localStorage.removeItem(DEVICE_CODE);
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      localStorage.removeItem(EXPIRATION_DATE);
      //revoked the device code, so we need to clear the local storage and reload the page to show the activation screen again.
      window.location.reload();
      return Promise.resolve({
        ...error.response,
        data: null
      });
    }

    if (status === 401) {
      localStorage.removeItem(DEVICE_CODE);
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      localStorage.removeItem(EXPIRATION_DATE);
      window.location.reload();
    }

    return Promise.reject(error?.response?.data?.Message ?? error);
  }
);
